{
  "el": {
    "locale_field": {
      "fallback_tooltip": "Όταν δεν έχει συμπληρωθεί κείμενο για αυτή τη γλώσσα, θα χρησιμοποιηθεί αυτό το προεπιλεγμένο κείμενο.",
      "translated_in": "Μεταφρασμένο σε"
    }
  }
}
